<template>
  <b-card title="Error" header-tag="header" footer-tag="footer">
    <template #header>
      <h6 class="mb-0">Ooops... error !</h6>
    </template>
    <b-card-text>
      <div v-if="error && error.statusCode === 404">
        Halaman yang Anda cari tidak ditemukan (404).
      </div>
      <div v-else>
        Mohon maaf, telah terjadi kesalahan pada sistem.
      </div>
    </b-card-text>
    <b-button variant="primary" @click="goBack">Kembali</b-button>
    <b-button v-if="isAuthenticated" variant="info" class="ml-2" @click="goToDashboard">Ke Dashboard</b-button>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  layout: 'error',
  middleware: [], // No auth middleware for error pages
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['loggedIn']),
    isAuthenticated() {
      return this.loggedIn
    },
  },
  data() {
    return {
      pageNotFound: '404 - Halaman tidak ditemukan',
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else if (this.isAuthenticated) {
        this.$router.push('/admin/home')
      } else {
        this.$router.push('/')
      }
    },
    goToDashboard() {
      if (this.isAuthenticated) {
        this.$router.push('/admin/home')
      } else {
        this.$router.push('/auth/login')
      }
    },
  },
  head() {
    const title = this.error?.statusCode === 404 ? this.pageNotFound : 'Error'
    return {
      title,
    }
  },
}
</script>

<style scoped>
h1 {
  font-size: 20px;
}
</style>
